<template>
    <div id="csContainer"></div>
</template>
<script>
import util from "../../components/util"
import {SmxEarth} from "../../js/smxEarth"
export default {
    data () {
        return {
            viewer:null
        }
    },
    mounted(){
      this.init();
    },
    methods:{
        init () {
            this.viewer=util.getViewer('csContainer',{
                 shouldAnimate: true,
                 infoBox:true,
                 selectionIndicator: true,
            });

            //添加雷达扫描。
                var radarScan = SmxEarth.addRadarScan( this.viewer,{
                    lon:117.217124,//经度
                    lat:31.809777, //纬度
                    scanColor:new Cesium.Color(1.0, 0.1, 0.1, 1),//红，绿，蓝，透明度
                    r:1500,//扫描半径
                    interval:4000//时间间隔
                });
                //飞行到这个位子
                this.viewer.camera.flyTo({
                    destination : Cesium.Cartesian3.fromDegrees(117.217124,31.809777, 15000.0),
                    orientation: {
                        heading : Cesium.Math.toRadians(90.0), // east, default value is 0.0 (north) //东西南北朝向
                        pitch : Cesium.Math.toRadians(-90),    // default value (looking down)  //俯视仰视视觉
                        roll : 0.0                             // default value
                    },
                    duration:3
                });
        },
    }
}
</script>
<style scoped>
#csContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>